import * as moment from 'moment';

export type MomentIntervalField = 'years' | 'days' | 'hours' | 'minutes' | 'seconds' | 'miliseconds';
export class MomentInterval {
  years: number;
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  miliseconds: number;
  isNegative: boolean;

  constructor(public dt1: moment.Moment, public dt2: moment.Moment) {
    this.calculate();
  }


  private calculate() {
    const baseMS = this.dt1.diff(this.dt2);
    this.isNegative = baseMS < 0;

    const base = Math.abs(baseMS)

    this.miliseconds = base % 1000;
    let remain = (base - this.miliseconds) / 1000;
    this.seconds = remain % 60;
    remain = (remain - this.seconds) / 60;
    this.minutes = remain % 60;
    remain = (remain - this.minutes) / 60;
    this.hours = remain % 24;
    remain = (remain - this.hours) / 24;
    this.days = remain % 365;
    remain = (remain - this.days) / 365;
    this.years = remain
  }

  private pad(value: number) {
    return ('00' + value?.toString()).slice(-2);
  }

  toString() {
    // Pad to 2 or 3 digits, default is 2
    function pad(n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    }
    let resp = pad(this.hours, 2) + ':' + pad(this.minutes, 2) + ':' + pad(this.seconds, 2);
    if (this.days > 0) {
      resp = this.days + ' dias ' + resp;
    }

    if (this.years > 0) {
      resp = this.years + ' anos ' + resp;
    }

    return resp;
  }

  padded(field: MomentIntervalField) {
    const paddeds: MomentIntervalField[] = ['hours', 'minutes', 'seconds'];
    if (paddeds.includes(field)) {
      return this.pad(this[field] ?? 0);
    } else {
      return this[field]?.toString() ?? '';
    }
  }


}
export class DT {

  static DiffInHours(data: Date, now?: Date): number {

    if (!now) { now = new Date(); }

    const dt2 = data;
    const dt1 = now;

    let diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    diff /= 60;
    return Math.abs(Math.round(diff));
  }

  static DiffInMinutes(data: Date, now?: Date) {
    if (!now) { now = new Date(); }
    let diff = (now.getTime() - data.getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
  }

  static DiffInSeconds(data: Date, now?: Date) {
    if (!now) { now = new Date(); }
    const diff = (now.getTime() - data.getTime()) / 1000;
    return Math.abs(Math.round(diff));
  }

  static DiffInDays(data: Date, now?: Date) {
    if (!now) { now = new Date(); }

    const dt2 = data;
    const dt1 = now;

    let diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    diff /= 60;
    diff /= 24;
    return Math.abs(Math.round(diff));
  }

  static humanReadable(dt: Date) {
    const dm = DT.DiffInMinutes(dt);
    const dh = DT.DiffInHours(dt);
    const dd = DT.DiffInDays(dt);

    if (dm < 60) {
      return dm + ' m';
    }

    if (dh < 24) {
      return dh + ' h';
    }

    return dd + ' d';

  }


  static msToHuman(baseMS) {

    // Pad to 2 or 3 digits, default is 2
    function pad(n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    }

    const base = Math.abs(baseMS)

    const ms = base % 1000;
    let remain = (base - ms) / 1000;
    const ss = remain % 60;
    remain = (remain - ss) / 60;
    const mm = remain % 60;
    remain = (remain - mm) / 60;
    const hh = remain % 24;
    remain = (remain - hh) / 24;
    const dd = remain % 365;
    remain = (remain - dd) / 365;
    const yy = remain

    let resp = pad(hh, 2) + ':' + pad(mm, 2) + ':' + pad(ss, 2);
    if (dd > 0) {
      resp = dd + ' dias ' + resp;
    }

    if (yy > 0) {
      resp = yy + ' anos ' + resp;
    }


    return resp;
  }
}
